export type SocialTuningSettings = {
  friendSearchLimit: number;
  searchWeightMutual: number;
  searchWeightFit: number;
  searchWeightInterests: number;
  feedMinPostChars: number;
  feedHideLowSignal: boolean;
  weeklyMissionEnabled: boolean;
};

const TUNING_KEY = "tension.social.tuning.v1";

const DEFAULT_TUNING: SocialTuningSettings = {
  friendSearchLimit: 8,
  searchWeightMutual: 9,
  searchWeightFit: 0.55,
  searchWeightInterests: 7,
  feedMinPostChars: 22,
  feedHideLowSignal: true,
  weeklyMissionEnabled: true,
};

function toNumber(value: unknown, fallback: number, min: number, max: number): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, n));
}

export function getDefaultSocialTuningSettings(): SocialTuningSettings {
  return { ...DEFAULT_TUNING };
}

export function readSocialTuningSettings(): SocialTuningSettings {
  if (typeof window === "undefined") return getDefaultSocialTuningSettings();
  try {
    const raw = window.localStorage.getItem(TUNING_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return {
      friendSearchLimit: Math.round(
        toNumber(parsed?.friendSearchLimit, DEFAULT_TUNING.friendSearchLimit, 4, 20),
      ),
      searchWeightMutual: toNumber(parsed?.searchWeightMutual, DEFAULT_TUNING.searchWeightMutual, 0, 25),
      searchWeightFit: toNumber(parsed?.searchWeightFit, DEFAULT_TUNING.searchWeightFit, 0, 2),
      searchWeightInterests: toNumber(
        parsed?.searchWeightInterests,
        DEFAULT_TUNING.searchWeightInterests,
        0,
        20,
      ),
      feedMinPostChars: Math.round(
        toNumber(parsed?.feedMinPostChars, DEFAULT_TUNING.feedMinPostChars, 0, 280),
      ),
      feedHideLowSignal: parsed?.feedHideLowSignal ?? DEFAULT_TUNING.feedHideLowSignal,
      weeklyMissionEnabled: parsed?.weeklyMissionEnabled ?? DEFAULT_TUNING.weeklyMissionEnabled,
    };
  } catch {
    return getDefaultSocialTuningSettings();
  }
}

export function writeSocialTuningSettings(next: SocialTuningSettings): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(TUNING_KEY, JSON.stringify(next));
  } catch {
    // noop
  }
}

export function resetSocialTuningSettings(): SocialTuningSettings {
  const defaults = getDefaultSocialTuningSettings();
  writeSocialTuningSettings(defaults);
  return defaults;
}

